<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('常见问题解决状态.用户信息')">
                <a-input v-model="queryParam.userInfo" @pressEnter="handleQuery" allow-clear
                         :placeholder="$t('常见问题解决状态.用户信息搜索提示')"/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('常见问题解决状态.解决状态')">
                <a-select :placeholder="$t('通用.输入.请选择')+$t('常见问题解决状态.解决状态')" style="width: 100%" v-model="queryParam.solveStatus" allowClear>
                  <a-select-option v-for="(item, index) in customDict.SolveStatusEnum" :value="item.type" :key="index">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{$t('通用.按钮.查询')}}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{$t('通用.按钮.重置')}}</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 数据表格 -->
      <a-table
        :loading="loading"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="userInfo" slot-scope="text, record">
          {{$t('常见问题解决状态.昵称')}}：{{ record.nickName || '-' }} <br/>
          {{$t('常见问题解决状态.手机号')}}：{{ record.mobile || '-' }}
        </span>
        <span slot="solveStatus" slot-scope="text, record">
          <a-tag>{{ getDictName(customDict.SolveStatusEnum, record.solveStatus) }}</a-tag>
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :pageSizeOptions="pageSizeOptions"
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => getTotal(total)"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageProblemSolve } from '@/api/help/problemSolve'
import { tableMixin } from '@/store/table-mixin'
import { mapGetters } from 'vuex'

export default {
  name: 'ProblemSolve',
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      pageSizeOptions: ['10', '20', '50', '100'],
      selectedRowKeys: [],
      loading: false,
      total: 0,
      queryParam: {
        userInfo: undefined,
        solveStatus: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: this.$t('常见问题解决状态.问题标题'),
          dataIndex: 'problemTitle',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('常见问题解决状态.用户信息'),
          dataIndex: 'userInfo',
          scopedSlots: { customRender: 'userInfo' },
          width: 200,
          align: 'center'
        },
        {
          title: this.$t('常见问题解决状态.解决状态'),
          dataIndex: 'solveStatus',
          scopedSlots: { customRender: 'solveStatus' },
          align: 'center'
        },
        {
          title: this.$t('常见问题解决状态.未解决原因'),
          dataIndex: 'reason',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('常见问题解决状态.创建时间'),
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          align: 'center'
        }
      ]
    }
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  created () {
    this.getList()
  },
  methods: {
    getTotal(total) {
      return this.$t('通用.文本.共')+total+this.$t('通用.文本.条')
    },
    /** 查询列表 */
    getList () {
      this.loading = true
      const param = { ...this.queryParam }
      // userInfo 搜索框同时搜索昵称和手机号（OR关系）
      if (param.userInfo) {
        param.nickName = param.userInfo
        delete param.userInfo
      }
      pageProblemSolve(param).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        userInfo: undefined,
        solveStatus: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    /** 根据枚举type从customDict中匹配显示name */
    getDictName (options, type) {
      if (!options || type === null || type === undefined) {
        return '-'
      }
      const item = options.find(o => String(o.type) === String(type))
      return item ? item.name : '-'
    }
  }
}
</script>
